import { render } from "./Contact.vue?vue&type=template&id=79d0485d&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=79d0485d&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__